import { useEffect, useRef, useState } from 'react'
import '../styles/CodeLineage.scss'
import SearchableDropdown from '../components/SearchableDropdown'
import downloadIcon from '../assets/png/ico_download.png'
// import downloadIconWhite from '../assets/svg/ico_download_white.svg'
import StatusModal from '../components/StatusModal'
import ChatBot from '../components/ChatBot'
import Button from '../components/Button'
import { getKBInsight, getKBInsightAnswer } from '../api/kbAccelerator.api'
import Trace from '../components/Trace'
import InfoModal from '../components/InfoModal'
import { Toast } from 'primereact/toast'
import { Tooltip } from 'primereact/tooltip'
import { LiaHandPointUp } from 'react-icons/lia'
// import { HiMiniArrowTurnDownRight } from "react-icons/hi2";
// import { PiArrowBendDownRightBold } from "react-icons/pi";



function getFileName(url) {
  try {
    if (!url) {
      return false
    }
    const u = new URL(url);
    const cd = u.searchParams.get('response-content-disposition');
    const match = cd && cd.match(/filename\*?=(?:UTF-8''|)([^;]+)/i);
    if (match) return decodeURIComponent(match[1].replace(/"/g, ''));
    return decodeURIComponent(u.pathname.split('/').pop());
  } catch {
    return url.split('?')[0].split('/').pop();
  }
}


function KBAccelerator() {
  const [projectRepoList, setProjectRepoList] = useState([])
  const [selectedProjectType, setSelectedProjectType] = useState(null)
  const [selectedProjectRepo, setSelectedProjectRepo] = useState(null)
  // const [pageLoader, setPageLoader] = useState(false);
  const [traceUrl, setTraceUrl] = useState(null);
  const [traceData, setTraceData] = useState([]);
  const [modal, setModal] = useState({
    open: false,
    type: "success",
    message: ""
  });
  const [messages, setMessages] = useState([]);
  const [traceFiles, setTraceFiles] = useState([]);
  const [input, setInput] = useState("");
  const [loadingChat, setLoadingChat] = useState(false);
  const [selectedId, setSelectedId] = useState(false);
  const [responseType, setResponseType] = useState(null);

  const [KTfileName, setKTfileName] = useState('');
  const [generatedFileName, setgeneratedFileName] = useState('')
  const [sessionId, setSessionId] = useState("");
  // const [expanded, setExpanded] = useState(false);
  const toast = useRef(null);

  const hintsList = [
    "What is PMO Portal?",
    "How to create a new temporary project?",
    "What are the modules can be accessed by the managers?"
  ];
  const projectTypeList = [
    // { name: "Business application", id: 1 },
    // { name: "Backend", id: 2 },
    // { name: "Integration", id: 3 },
    // { name: "Database", id: 4 },
    // { name: "Data Migration ", id: 5 },
    // { name: "Java", id: 6 },
    // { name: "ETL", id: 7 },
    // {name:"Cobol",id:8}
    { name: "Application Integration", id: 1, projectname: "Aurora Integration Suite (AIS)", filepath: "Documents/Application_Integration_doc_v1.0_WithDummyData" },
    { name: "Data Migration", id: 3, projectname: "NovaDW Migration", filepath: "Documents/Datawarehouse_Migration_doc_v1.2_WithDummyData" },
    { name: "OLTP", id: 2, projectname: "NimbusMarket Full-Stack Application", filepath: "Documents/Application_FullStack_doc_v1.0_WithDummyData" },
  ];

  const Master_projectRepo_options = [
    // { name: "GE data migration ", id: 1 },
    // { name: "PMO Integration", id: 3 },
    { name: "PMO", id: 2 },
    // { name: "MRMA", id: 2 }
  ];


  // Load data from localStorage on component mount 
  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem("chatData"));
    // console.log('storedData', storedData);
    if (storedData && !isDataExpired(storedData.timestamp)) {
      setMessages(storedData.messages || []);
      setSelectedProjectType(storedData.selectedProjectType)
      setSelectedProjectRepo(storedData.selectedProjectRepo)
      const repoList = Master_projectRepo_options.filter(e => e?.id === storedData?.selectedProjectType?.id)
      setProjectRepoList(repoList)
      setSessionId(storedData.sessionId || generateSessionId());

      if (storedData && storedData.messages && storedData.messages.length > 0) {
        const firstItem = storedData?.messages[0]
        const item = storedData?.messages[storedData?.messages.length - 1];
        // console.log("autosave chat data", item)
        setSelectedId(item.id);
        setResponseType(item.response_type)
        if (item.response_type === 1) {
          setTraceData(item.trace)
        }
        if (firstItem) {
          setTraceUrl(firstItem.trace);
          const generatedfile_name = getFileName(firstItem?.url)
          setKTfileName(firstItem?.url)
          setgeneratedFileName(generatedfile_name)
          setTraceFiles(firstItem.traceFiles)
        }
      }
    } else {
      const newSessionId = generateSessionId();
      setSessionId(newSessionId);
      setMessages([]);
      setOpen(true);
      localStorage.removeItem("chatData");
    }

  }, []);

  useEffect(() => {
    if (sessionId && messages && messages.length > 0) {
      const chatData = {
        selectedProjectRepo,
        selectedProjectType,
        sessionId,
        messages,
        timestamp: new Date().toISOString(),
        traceFiles,
      };
      localStorage.setItem("chatData", JSON.stringify(chatData));
    }
  }, [sessionId, messages]);


  const [open, setOpen] = useState(false);

  const onProjectTypeSelect = (value) => {
    setSelectedProjectType(value);
    const repoList = Master_projectRepo_options.filter(e => e?.id === value?.id)
    setProjectRepoList(repoList)
    setSelectedProjectRepo(null)
    setTraceUrl(null)
    setKTfileName(null)
    setgeneratedFileName(null)
    setMessages([])
    setTraceData([])

  };

  const sendUserMessage = async () => {
    if (!input.trim()) return;
    const userMsg = {
      id: `user-${Date.now()}`,
      type: "user",
      content: input,
      timestamp: new Date().toISOString(),
    };
    setMessages(prev => [...prev, userMsg]);
    setInput("");
    setLoadingChat(true);
    try {
      const payload = { sessionId: sessionId, inputText: input };
      const response = await getKBInsightAnswer(payload)
      if (response.status === 200) {
        const resData = response.data;
        const rawText = resData.sources[0].text || "No answer provided.";
        const cleanedText = rawText.replace(/\\n/g, "\n");
        typeBotReply({
          text: cleanedText,
          response_type: 1,
          trace: resData?.trace || null,
          url: resData?.url || null,
          traceFiles: null
        },
          (botId, msg) => {
            setSelectedId(botId);
            setTraceData(msg.trace)
            setResponseType(msg.response_type)
          }
        );
      }
      else {
        typeBotReply({
          text: 'Something went wrong. Please try again.',
          response_type: 1,
          trace: null,
          url: null
        });
      }
    } catch (err) {
      typeBotReply({
        text: 'Something went wrong. Please try again.',
        response_type: 1,
        trace: null,
        url: null
      });

    } finally {
      setLoadingChat(false);
    }
  };

  const typeBotReply = (
    { text, response_type, trace, url, traceFiles },
    onComplete
  ) => {
    let index = 0;

    const botId = `bot-${Date.now()}`;

    const botMsg = {
      id: botId,
      type: "bot",
      content: "",
      timestamp: new Date().toISOString(),
      response_type,
      trace,
      traceFiles,
      url
    };

    setMessages(prev => [...prev, botMsg]);

    const interval = setInterval(() => {
      index++;

      setMessages(prev =>
        prev.map(msg =>
          msg.id === botId
            ? { ...msg, content: text.slice(0, index) }
            : msg
        )
      );

      if (index >= text.length) {
        clearInterval(interval);
        // 🔘 Only call if provided
        if (typeof onComplete === "function") {
          onComplete(botId, botMsg);
        }
      }
    }, 20);
  };

  const chatClick = (msg) => {
    // console.log('msg', msg);
    if (msg?.type !== "user" && msg?.response_type === 2) {
      setSelectedId(msg.id);
      setTraceUrl(msg.trace);
      setResponseType(msg.response_type)
      const generatedfile_name = getFileName(msg?.url)
      setKTfileName(msg?.url)
      setgeneratedFileName(generatedfile_name)
      setTraceFiles(msg?.traceFiles)
    }
    else if (msg?.type !== "user" && msg?.response_type === 1) {
      setSelectedId(msg.id);
      setTraceData(msg.trace)
      setResponseType(msg.response_type)
    }
  };


  const getInsight = async () => {
    try {
      setLoadingChat(true);
      // setExpanded(true)
      const body = {
        sessionId: selectedProjectType?.name + '_' + selectedProjectRepo?.name
      }
      const response = await getKBInsight(body);
      if (response.status === 200) {
        const resData = response?.data
        const fullReply = `Your Project insight based on 
          Project type: ${selectedProjectType?.name}
          Repository: ${selectedProjectRepo?.name}, 
          To view the insight details, please download the generated document 👉
          To access the trace details, please download the TraceLogs file 👉
          ` || "No answer provided.";
        typeBotReply({
          text: fullReply,
          response_type: 2,
          trace: resData?.trace_url || null,
          url: resData?.url || null,
          traceFiles: resData?.trace
        }, (botId, msg) => {
          setSelectedId(botId);
          setTraceUrl(msg.trace);
          setResponseType(msg.response_type)
        }

        );
        const generatedfile_name = getFileName(resData?.url)
        setKTfileName(resData?.url)
        setgeneratedFileName(generatedfile_name) //(parts[parts.length - 1])
        setTraceFiles(resData?.trace)
        console.log('resData?.trace', resData?.trace);

      }
      else {
        typeBotReply({
          text: 'Something went wrong. Please try again.',
          response_type: 2,
          trace: null,
          url: null
        });
      }
    } catch (error) {
      console.error("Error fetching Data", error.message);
      setMessages([]);
      setSessionId(generateSessionId());
      localStorage.removeItem("chatData");
      typeBotReply({
        text: 'Something went wrong. Please try again.',
        response_type: 2,
        trace: null,
        url: null,
        traceFiles: null
      });
    } finally {
      setLoadingChat(false);
    }
  }

  const generateSessionId = () =>
    `session_${Math.random().toString(36).substr(2, 9)}`;
  const isDataExpired = (storedTimestamp) => {
    const currentTime = new Date();
    const storedTime = new Date(storedTimestamp);
    const timeDifference = currentTime - storedTime; // in milliseconds
    const sevenDaysInMilliseconds = 7 * 24 * 60 * 60 * 1000;
    return timeDifference > sevenDaysInMilliseconds;
  };

  const handleLinkClick = (event) => {
    event.preventDefault()

    const a = document.createElement('a');
    a.href = KTfileName;
    a.download = ''; // lets the browser infer the filename
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    a.remove();
    toast.current.show({ severity: 'success', summary: 'Success', detail: 'File downloaded', life: 3000 });
  }

  const downloadInsight = () => {
    if (generatedFileName) {
      const a = document.createElement('a');
      a.href = KTfileName;
      a.download = ''; // lets the browser infer the filename
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      a.remove()
      toast.current.show({ severity: 'success', summary: 'Success', detail: 'File downloaded', life: 3000 });
    }
  }

  const clearChat = () => {
    setSelectedId(null);
    setMessages([])
    setSessionId(generateSessionId());
    setgeneratedFileName(null)
    setTraceUrl(null)
    setTraceData([]);
    localStorage.removeItem("chatData");
    localStorage.clear()
    sessionStorage.clear()
  };
  const fileDownload = (e) => {
    e.preventDefault();
    const a = document.createElement('a');
    a.href = traceUrl;
    a.download = '';
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    a.remove();
    toast.current.show({ severity: 'success', summary: 'Success', detail: 'File downloaded', life: 3000 });
  };



  const hintsItemPress = (text) => {
    // setExpanded(true)
    handleSend(text);
  };

  const handleSend = async (text) => {
    const messageText = text;
    if (!messageText.trim()) return;
    const userMsg = {
      id: `user-${Date.now()}`,
      type: "user",
      content: messageText,
      timestamp: new Date().toISOString(),
    };
    setMessages(prev => [...prev, userMsg]);
    setInput("");
    setLoadingChat(true);
    try {
      const payload = { sessionId: sessionId, inputText: messageText };
      const response = await getKBInsightAnswer(payload)
      if (response.status === 200) {
        const resData = response.data;
        const rawText = resData.sources[0].text || "No answer provided.";
        const cleanedText = rawText.replace(/\\n/g, "\n");
        typeBotReply({
          text: cleanedText,
          response_type: 1,
          trace: resData?.trace || null,
          url: resData?.url || null
        },
          (botId, msg) => {
            setSelectedId(botId);
            setTraceData(msg.trace)
            setResponseType(msg.response_type)
          }
        );
      }
      else {
        setModal({
          open: true,
          type: "error",
          message: 'Failed to genarate response'
        });
        typeBotReply({
          text: 'Something went wrong. Please try again.',
          answerGraphUrl: null,
          answerGraphUrlString: null
        });
      }
    } catch (err) {
      setModal({
        open: true,
        type: "error",
        message: "Something went wrong. Please try again."
      });
      typeBotReply({
        text: 'Something went wrong. Please try again.',
        answerGraphUrl: null,
        answerGraphUrlString: null
      });
    } finally {
      setLoadingChat(false);
    }
  };

  const [activeIndex, setActiveIndex] = useState(null);
  const [expanded, setExpanded] = useState(false)
  const handleToggle = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const downloadFile = (fileUrl) => {
    try {
      // console.log("Downloading:", fileUrl);

      const link = document.createElement("a");
      link.href = fileUrl;
      link.setAttribute("download", fileUrl.split("/").pop()); // filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };


  return (
    <>
      <section className="clTopSection d-flex align-items-center">
        <div className="row g-2 w-100">
          <div className="col-12 col-lg-3 p-0 d-flex align-items-center">
            {/* <label className='clText'>Insight Hub</label> */}
            <div className='dropDownSection w-100'>
              <label className='labelText5'>Application type</label>
              <SearchableDropdown
                options={projectTypeList}
                label="name"
                id="id"
                selectedVal={selectedProjectType}
                handleChange={(value) => {
                  onProjectTypeSelect(value)
                }}
                placeholder='Please select'
                showClear={false}
              />
            </div>
          </div>
          <div className="col-12 col-lg-3 p-0">
            <div className='dropDownSection w-100'>
              <label className='labelText'>Project repository</label>
              <SearchableDropdown
                options={projectRepoList}
                label="name"
                id="id"
                selectedVal={selectedProjectRepo}
                handleChange={(value) => {
                  setSelectedProjectRepo(value)
                  setTraceUrl(null)
                  setKTfileName(null)
                  setgeneratedFileName(null)
                  setMessages([])
                  setTraceData([])
                }}
                placeholder='Please select'
                showClear={true}
                disabled={!selectedProjectType}
              />
            </div>
          </div>
          <div className="col-6 col-lg-4 p-0 ps-lg-3">
            <Button
              variant="primary"
              disabled={!(selectedProjectType && selectedProjectType.id && selectedProjectRepo && selectedProjectRepo.id)}
              onClick={() => getInsight()}>GET INSIGHT
            </Button>
          </div>
          <div className="col-6 col-lg-2 d-flex align-items-center justify-content-around p-0">
            <span className='clOptionText' onClick={downloadInsight}>
              <img src={downloadIcon} alt="download" className='clOptionIcon' />Download
            </span>
            <span className='clOptionText' onClick={() => setOpen(true)}>
              <i className='IconHelp' />
            </span>
          </div>
        </div>
      </section>
      <section className='graphSection2'>
        <div className="row w-100 h-100">
          <div
            // className={`transition-col ${expanded ? "col-5" : "col-11"}`}
            className='col-12 col-lg-5'
          >
            <ChatBot
              messages={messages}
              inputValue={input}
              onInputChange={setInput}
              onSend={sendUserMessage}
              onMessageClick={chatClick}
              loading={loadingChat}
              disabled={!(selectedProjectType && selectedProjectRepo)}
              selectedId={selectedId}
              // disabledText='Please select a project type & repository to enable chat.'
              disabledText={<>
                <div className='disabledChatMessage'>
                  {/* <i className='LeftHandIcon'></i> */}
                  <LiaHandPointUp className="bottomHand" />
                  <p style={{ marginTop: '1.5rem' }}> Please select a application type <br /> & repository to enable chat.</p>
                </div>
              </>}
              // blankText='Get Insight From The Project Repository'
              chatBotHintsStatus={true}
              hintsList={hintsList}
              hintsItemPress={hintsItemPress}
            />
          </div>
          <div
            // className={`transition-col ${expanded ? "col-7" : "col-1"}`}
            className='col-12 col-lg-7'
          >
            <div className="graphImageBlock">
              {messages && messages.length > 0 &&
                <>
                  <Tooltip target=".clearIcon" />
                  <span className='clearIcon'
                    onClick={() => clearChat()}
                    data-pr-tooltip="Clear chats"
                    data-pr-position="left"
                  >
                    <i className='ClearIcon3'></i>
                  </span>
                </>
              }
              {generatedFileName && traceUrl && responseType === 2 &&
                <>
                  <div className='fileSection'>
                    <div className='downloadSection'>
                      <div className='boxContain'>
                        <div className='d-flex'>
                          <div className='iconDiv'>
                            <i className='DownloadTraceIcon' onClick={handleLinkClick} title='Click here to download the detailed insights.'></i>
                          </div>
                          <div className='traceFooter'>
                            <div className='footerText'>
                              <p >
                                Download this AI summary of the application and repository, providing key insights for informed decisions.
                              </p>
                            </div>
                            <span className='fileName' >
                              <button className='insightsBtn' onClick={handleLinkClick} title='Click here to download the detailed insights.'>
                                <img src={require("../assets/png/file-download-icon.png")} height={30} alt="download" className="traceImage" />
                                Download
                              </button>
                            </span>
                            <hr />
                            <div className='footerText'>
                              <p >
                                Download the repository trace for code relationships and dependencies. Validate manually as needed.
                                <br />
                                <span className='traceLogBtn' onClick={fileDownload} title='Click here to download trace logs.'>
                                  Full TraceLogs &gt;&gt;
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="trace-panel">
                      <span className='headText'>Reasoning and Execution log</span>
                      <span
                        className={`trace-title ${expanded ? "open" : ""}`}
                        onClick={() => setExpanded(!expanded)}
                      >
                        Most Relevant Evidences
                        {/* <span className="arrow">{expanded ? "▲" : "▼"}</span> */}
                      </span>

                      {expanded && (
                        <div className="trace-content">
                          <ul className="trace-list">
                            {traceFiles.map((uri, index) => (
                              <li key={index} className="trace-item">
                                <div
                                  className="trace-link"
                                  onClick={() => downloadFile(uri)}
                                >
                                  {/* {uri.split("/").pop()} */}
                                  {uri}
                                </div>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>
                </>
              }
              {traceData && traceData.length > 0 && responseType === 1 &&
                <Trace
                  traceData={traceData}
                  title='Reasoning and Execution log'
                />
              }
            </div>
          </div>
          {/* <button className='traceButton'>
            <IoIosSearch style={{ fontSize: '35px' }} />
            TRACE
          </button> */}
        </div>
      </section>
      <StatusModal
        open={modal.open}
        type={modal.type}
        message={modal.message}
        onClose={() => setModal({ ...modal, open: false })}
        autoClose={false}
        duration={5000}
      />
      <InfoModal
        open={open}
        onClose={() => setOpen(false)}
        heading={<>
          Please select a application type and then choose a repository from the top dropdown menus. After that,
          <br />
          click the <strong>‘INSIGHT’</strong> button to view the detailed insight.
        </>}
        download='Download detailed insight document'
        title='Insight hub help'
        type={2}
      />
      <Toast ref={toast} position="top-center" />
    </>
  )
}




export default KBAccelerator
